window.initVendorInventoryUpdate = function() {
  if (!document.getElementById('addInventoryBtn')) return; // vendor buttons absent on most pages
  console.log("[initVendorInventoryUpdate] Initializing vendor inventory update script...");

  const vendorKey = window.vendorKey; 

  // Button Containers for each state.
  const addInventoryBtn = document.getElementById('addInventoryBtn');
  const editInventoryBtns = document.getElementById('editInventoryBtns');
  const saveInventoryBtn = document.getElementById('saveInventoryBtn');
  const exitInventoryBtn = document.getElementById('exitInventoryBtn');
  const btnGroup = document.getElementById('action-toggle');

  // Inventory elements on the page.
  const vendorDisplays = document.querySelectorAll('.vendor-inventory-display');
  const vendorToggles = document.querySelectorAll('.vendor-inventory-toggle');

  let isEditMode = false;

  function enterEditMode() {
    vendorDisplays.forEach(display => { display.style.display = 'none'; });
    vendorToggles.forEach(toggle => {
      toggle.style.display = 'block';
      const input = toggle.querySelector('.v-inventory-input');
      if (input) {
        input.dataset.originalValue = input.value;
        input.addEventListener('input', onInputChange);
      }
    });
    addInventoryBtn.style.display = 'none';
    btnGroup.style.display = 'none';
    editInventoryBtns.style.display = 'flex';
    saveInventoryBtn.classList.add("disabled");
    isEditMode = true;
  }

  function onInputChange() {
    saveInventoryBtn.classList.remove("disabled");
  }

  function exitEditMode() {
    vendorDisplays.forEach(display => { display.style.display = 'block'; });
    vendorToggles.forEach(toggle => {
      toggle.style.display = 'none';
      const input = toggle.querySelector('.v-inventory-input');
      if (input) { input.removeEventListener('input', onInputChange); }
    });
    addInventoryBtn.style.display = 'block';
    btnGroup.style.display ='flex';
    editInventoryBtns.style.display = 'none';
    isEditMode = false;
    
  }

  async function saveInventoryUpdates() {
    showvpLoadingModal("Updating Inventory...");
    const cartItems = [];
    const changedData = []; // Array for additional sync data
    const variantBlocks = document.querySelectorAll('.open-variant-drawer');
    
    variantBlocks.forEach(block => {
      const variantId = block.dataset.variantId;
      const input = block.querySelector('.v-inventory-input');
      if (input) {
        const originalValue = input.dataset.originalValue;
        const newValue = input.value;
        if (newValue !== originalValue) {
          // Build cartItems for Shopify update.
          cartItems.push({
            variant_id: variantId,
            vendor_key: vendorKey,
            newInventory: newValue
          });
          // Build changedData for historical sync.
          changedData.push({
            variant_id: block.dataset.variantId || "",
            variant_title: block.dataset.variantTitle || "",
            variant_category: block.dataset.variantCategory || "",
            variant_order: block.dataset.variantOrder || "",
            in_stock: newValue // new inventory count
          });
        }
      }
    });
    
    if (cartItems.length === 0) {
      exitEditMode();
      hidevpLoadingModal();
      return;
    }
    
    try {
      const updateResult = await updateInventory(cartItems);
      console.log("Update result:", updateResult);
      
      // Update display with new values.
      variantBlocks.forEach(block => {
        const input = block.querySelector('.v-inventory-input');
        if (input) {
          const newValue = input.value;
          const displayElem = block.querySelector('.vendor-inventory-display span');
          if (displayElem) {
            if (parseInt(newValue, 10) > 0) {
              displayElem.textContent = `${newValue} In Stock`;
              displayElem.style.color = "#256029";
              displayElem.style.backgroundColor = "#e6f9e6";
            } else {
              displayElem.textContent = "Out of Stock";
              displayElem.style.color = "#6b7280";
              displayElem.style.backgroundColor = "#f3f4f6";
            }
            input.dataset.originalValue = newValue;
          }
        }
      });
      
      // Do not show the success modal here; instead, trigger the sync.
      exitEditMode();
      
      // Now trigger the historical sync with only the changed rows.
      if (window.initInventorySync) {
        console.log("[initVendorInventoryUpdate] Triggering inventory sync with changed data:", changedData);
        window.initInventorySync(changedData);
      }
      
    } catch (error) {
      console.error("Error updating inventory:", error);
      updatevpLoadingModal("Error updating inventory. Please try again.");
      document.getElementById("vp-loading-modal-close").style.display = "inline-block";
    }
  }

  addInventoryBtn.addEventListener('click', function() {
    if (!isEditMode) { enterEditMode(); }
  });

  saveInventoryBtn.addEventListener('click', function() {
    if (isEditMode && !saveInventoryBtn.classList.contains("disabled")) {
      saveInventoryUpdates();
    }
  });

  exitInventoryBtn.addEventListener('click', function() {
    exitEditMode();
  });

  function updateInventory(cartItems) {
    return new Promise(async function(resolve, reject) {
      const inventoryScriptUrl = "https://script.google.com/macros/s/AKfycby4d2NHSS1sRQCpW3pfZQ1IqjKkIcAUPm3NvDv1y2HYV3eyCEYfD68Rz7H_qoWSlwo8/exec";
      try {
        console.log("Inventory update payload:", { cart_items: cartItems });
        const response = await fetch(inventoryScriptUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({ cart_items: cartItems })
        });
        const result = await response.json();
        resolve(result);
      } catch (error) {
        reject(error);
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  console.log("[DOMContentLoaded] DOM fully loaded. Initializing inventory update.");
  window.initVendorInventoryUpdate();
});
